import { IconDotsVertical } from '@tabler/icons-react'
import { DropdownProps, MenuProps } from 'antd'

import { Button, ButtonProps } from './BUI/Button'
import { Dropdown } from './BUI/Dropdown'

type Props = {
  menu: React.ReactElement<MenuProps>
  placement?: DropdownProps['placement']
  trigger?: DropdownProps['trigger']
  variant?: ButtonProps['variant']
  shape?: ButtonProps['shape']
  size?: ButtonProps['size']
}

const EllipsisDropdown: React.FC<Props> = ({
  menu,
  placement = 'bottomRight',
  trigger = ['click'],
  variant = 'secondary-text',
  shape = 'circle',
  size = 'small',
}) => {
  return (
    <Dropdown overlay={menu} placement={placement} trigger={trigger}>
      <Button
        size={size}
        shape={shape}
        variant={variant}
        icon={<IconDotsVertical size={16} />}
        onClick={(e) => e.stopPropagation()} // prevent event bubbling up, useful when used in a clickable table row
      />
    </Dropdown>
  )
}

export default EllipsisDropdown
